import i18n from 'javascript/i18n'

export const _timePrefix = (num) => (num < 10 ? `0${num}` : num)

const _displayTime = (realHour, realMin, space) =>
  space
    ? `${_timePrefix(realHour)} : ${_timePrefix(realMin)}`
    : `${_timePrefix(realHour)}:${_timePrefix(realMin)}`

const createTimeList = (hourIncrement = 1, minIncrement = 15, options = false, space = true) => {
  let timeLimited = { startTime: '00:00', endTime: '24:00' }
  if (options) {
    timeLimited = {
      startTime: options.startTime || timeLimited.startTime,
      endTime: options.endTime || timeLimited.endTime
    }
  }
  const timeList = []
  const startOption = timeLimited.startTime.split(':')
  const endOption = timeLimited.endTime.split(':')
  const startHour = Number(startOption[0])
  const startMin = Number(startOption[1])
  const endHour = Number(endOption[0])
  const endMin = Number(endOption[1])
  for (let h = 0; h < 24 / hourIncrement; h++) {
    const realHour = h * hourIncrement
    if (realHour >= startHour && realHour <= endHour) {
      for (let m = 0; m < 60 / minIncrement; m++) {
        const realMin = m * minIncrement
        if (realHour - startHour < hourIncrement) {
          realMin >= startMin && timeList.push(_displayTime(realHour, realMin, space))
        } else if (endHour - realHour < hourIncrement) {
          realMin <= endMin && timeList.push(_displayTime(realHour, realMin, space))
        } else {
          timeList.push(_displayTime(realHour, realMin, space))
        }
      }
    }
  }
  return timeList
}

export const _closest = (num, arr) => {
  let curr = arr[0]
  let diff = Math.abs(num - curr)
  for (let val = 0; val < arr.length; val++) {
    const newdiff = Math.abs(num - arr[val])
    if (newdiff < diff) {
      diff = newdiff
      curr = arr[val]
    }
  }
  return curr
}

export const getRoundTime = (defaultTime, hourIncrement = 1, minIncrement = 30, timeLimited) => {
  const options = timeLimited &&
    timeLimited.length > 0 && {
      startTime: timeLimited[0].start_time,
      endTime: timeLimited[0].end_time
    }
  const timeOptions = defaultTime.split(':')
  const defaultHour = Number(timeOptions[0])
  const defaultMin = Number(timeOptions[1])
  const hourList = []
  const minList = []
  for (let h = 0; h < 24 / hourIncrement; h++) {
    hourList.push(h * hourIncrement)
  }
  for (let m = 0; m < 60 / minIncrement; m++) {
    minList.push(m * minIncrement)
  }
  const hour = _closest(defaultHour, hourList)
  const min = _closest(defaultMin, minList)
  const time = `${_timePrefix(hour)} : ${_timePrefix(min)}`
  if (options) {
    const timeList = createTimeList(hourIncrement, minIncrement, options)
    return extractSpace(
      timeList.indexOf(time) > -1 ? time : timeList[parseInt(timeList.length / 2, 10)]
    )
  } else {
    return extractSpace(time)
  }
}

export const extractSpace = (time) => {
  return time.replace(/\s/g, '')
}

export const dateTimeFormat = (time) => {
  return time.replace(' ', 'T')
}

export const genExpirationForCard = (year, month) => {
  return year.toString().slice(2, 4) + month
}

export const genMonthList = () => {
  const list = []
  for (let i = 1; i < 13; i++) {
    list.push(i < 10 ? '0' + i : i.toString())
  }
  return list
}

export const genYearList = () => {
  const list = []
  const currentYear = new Date().getFullYear()
  for (let i = 0; i < 11; i++) {
    list.push(currentYear + i)
  }
  return list
}

export const currentYearMonth = () => {
  const today = new Date()
  const month = today.getMonth() + 1
  const formatedMonth = month < 10 ? '0' + month : month
  const year = today.getFullYear()
  return genExpirationForCard(year, formatedMonth)
}

export const inTimeRange = (availableTimeList, currentDate, callback) => {
  let result = null
  availableTimeList.some((timeRange) => {
    const selectedDateFormat = new Date(currentDate).getTime()
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    if (
      ((timeRange.start_date && new Date(timeRange.start_date)) || today).getTime() <=
        selectedDateFormat &&
      selectedDateFormat <= new Date(timeRange.end_date).getTime()
    ) {
      result = callback(timeRange)
      return true
    }
  })
  return result
}

export const formatDate = (date) => {
  const year = date.getFullYear()
  const month = _timePrefix(date.getMonth() + 1)
  const day = _timePrefix(date.getDate())
  return `${year}/${month}/${day}`
}

export function brrDateDisplay(adults, checkin, checkout) {
  const today = new Date()
  const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000)
  const theDayAfterTomorrow = new Date(today.getTime() + 2 * 24 * 60 * 60 * 1000)
  const checkinDate = new Date(checkin?.replace(/\//g, '-')) || tomorrow
  const checkoutDate = new Date(checkout?.replace(/\//g, '-')) || theDayAfterTomorrow
  const day1 = checkinDate.getDate()
  const day2 = checkoutDate.getDate()
  const month1 = checkinDate.getMonth() + 1
  const month2 = checkoutDate.getMonth() + 1
  const year1 = checkinDate.getFullYear()
  const year2 = checkoutDate.getFullYear()
  return year1 === year2
    ? `${month1}/${day1} - ${month2}/${day2} ${year1}, ${adults} ${i18n.tc('xAdults', adults)}`
    : `${year1}/${month1}/${day1} - ${year2}/${month2}/${day2}, ${adults} ${i18n.tc(
        'xAdults',
        adults
      )}`
}

export default createTimeList
